export const additionalInformationPageTitle = 'Additional information';

export const additionalInformationPageQuestion =
  'Is there anything else you want to tell us about your mental health conditions, or related traumatic events and behavioral changes?';
